import { render } from "./comfirmModal.vue?vue&type=template&id=2d2b92c6&scoped=true"
import script from "./comfirmModal.vue?vue&type=script&lang=js"
export * from "./comfirmModal.vue?vue&type=script&lang=js"

import "./comfirmModal.vue?vue&type=style&index=0&id=2d2b92c6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2b92c6"]])

export default __exports__